export enum ErrorStatusVx {
  ARRIVED = 'ARRIVED',
  FULFILLED = 'FULFILLED',
  CANCELLED = 'CANCELLED',
  NO_SHOW = 'NO_SHOW',
  CHECKED_IN = 'CHECKED_IN',
}

export enum ErrorStatusTab {
  PENDING = 'PENDING',
  NEXT24HOURS = 'NEXT24HOURS',
  PAST = 'PAST',
  CONFIRM = 'CONFIRM',
  NOSHOW = 'NOSHOW',
  CANCEL = 'CANCEL',
  COMPLETE = 'COMPLETE',
  OTHER = 'OTHER',
}
